import secureLocalStorage from "react-secure-storage";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import React, { PureComponent } from "react";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import "../../Styles/RiskViews.scss";
import ColumnMenu from "../Dashboard/ColumnMenu";
import CheckBox from "../Tenant/CheckBox";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import MitigationNameCell from "../Tenant/Component/MitigationNameCell";
import MitigationStatus from "../Tenant/Component/MitigationStatus";
export default class MitigationView extends PureComponent {
  constructor(props) {
    super(props);

    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      mitigationData: [],
      impactMaster: [],
      customFieldsmaster:[],
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.mitigationData !== prevProps.mitigationData) {
      this.createDynamicCols(this.props.mitigationData);
      this.createDynamicDropdownsForAction(this.props.mitigationData);
    }
  }
  //trigger method by parent
  refreshData = (data) => {
    this.createDynamicCols(data);
    this.createDynamicDropdownsForAction(data);
  };

  createDynamicDropdownsForAction = async (products) => {
    try {
      let dropdownColumn = [];
      products &&
        products.map((res, i) => {
          res.customFields &&
            res.customFields.map((item, j) => {
              if (dropdownColumn.length > 0) {
                if (
                  !dropdownColumn.find((cf) => cf.fieldName == item.fieldName)
                ) {
                  dropdownColumn.push({
                    fieldName: item.fieldName,
                    data: this.getCustomFieldMasterData(item.fieldName),
                    inputType: this.getInputType(item.fieldName),
                  });
                }
              } else {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            });
        });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText ? parseInt(temp.multiText) : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText ? new Date(temp.multiText) : "";
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {}
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster.find((item) => item.fieldName == fieldName);
      if (arr) {
        return arr.inputType;
      }else{
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };
  
  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: false,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data=cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      return <td title={value?value.toString():''}>{value?value.toString():''}</td>
    }else if(cfObj && cfObj.inputType === "Single Drop Down"){
      return <td title={value?value.toString():''}>{value?value.toString():''}</td>
    }else if(cfObj && cfObj.inputType === "Free Text"){
      return <td title={value?value.toString():''}>{value?value.toString():''}</td>
    }else if(cfObj && cfObj.inputType === "Numeric"){
      return <td title={value||value===0?formatNumber(parseInt(value), "##,#"):""}>{value||value===0?formatNumber(parseInt(value), "##,#"):""}</td>
    }else if(cfObj && cfObj.inputType === "Date"){
      return <td title={value?moment(value).format("DD-MMM-YYYY"):""}>{value?moment(value).format("DD-MMM-YYYY"):""}</td>
    }else{
      return <td></td>;
    }
  };

  createDynamicCols = async (products) => {
    let impactMaster = [];
    if (products && products.length > 0) {
      impactMaster = products[0].impactResponse;
    }

    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });
      }
    });
    
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.find((item) => item.name === col);
          if (temp) {
            res[col] =
              temp.impactType == "Quantitative" ? temp.value : temp.qValue;
          } else {
            res[col] = undefined;
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item}
          title={"Change in " + this.getImpactUnit(item, impactMaster)}
          width="100px"
          editable={false}
          filter={"numeric"}
           // columnMenu={ColumnMenu}
          cell={(props) => (
            <CurrencyFormat {...props} onEditCell={this.onEditCell} />
          )}
        />
      ));
    }
    this.setState({
      ...this.state,
      impactColumns: columnsToShow,
      mitigationData: products,
      mitigationDataTemp: products,
    });
  };
  getImpactUnit = (impact, impactMaster) => {
    var res = impact;
    var impactTemp = impactMaster.find((item) => item.name == impact);

    if (impactTemp && impactTemp.name) {
      let unit = impactTemp.units ? " / " + impactTemp.units : "";
      res = impactTemp.name + unit;
    }
    return res;
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  createAppState = (dataState) => {
    if (this.state && this.state.mitigationDataTemp) {
      return {
        mitigationData: this.state.mitigationDataTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        mitigationData: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => {};
  render() {
    return (
      <div className="riskViewCont">
        <div className="tblCont riskRegister dataGrids ActionTbl">
          <Grid
            data={process(this.state.mitigationData, this.state.dataState)}
            {...this.state.dataState}
            onDataStateChange={this.dataStateChange}
            reorderable
            resizable
            sortable={true}
            pageable={true}
            // total={this.state.mitigationData.length}
          >
            <Column
              field="organisationName"
              title="Workstream"
              width="200px"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="createdDate"
              width="100px"
              title="Created Date"
              filter={"date"}
              // columnMenu={ColumnMenu}
              format="{0:dd-MMM-yyyy}"
            />

            <Column
              field="isOpportunity"
              title="T/O"
              width="100px"
              cell={(props) =>
                props.dataItem.isOpportunity === "Threat" ? (
                  <td>{props.dataItem.isOpportunity}</td>
                ) : (
<td>
                      <span className="turquoiseBlue">
                        {props.dataItem.isOpportunity}
                      </span>
                    </td>                )
              }
            />
            <Column
              field="riskName"
              title="Risk"
              width="200px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="riskNumber"
              title="Risk Number"
              width="200px"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="name"
              title="Action Title"
              width="200px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="number"
              title="Action Number"
              width="120px"
              // columnMenu={ColumnMenu}
            />

            <Column
              field="control"
              title="Description"
              width="150px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="externalReference"
              title="External Reference"
              width="150px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="actionType"
              title="Action Type"
              width="150px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column field="riskTypeNames" title="Risk Type" width="150px" />
            {this.state.dropdownColumns}
            <Column
              field="cost"
              title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
              width="80px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <CurrencyFormat {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="reductionFrequency"
              width="80px"
              title="Change in Probability (%)"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <CurrencyFormat {...props} onEditCell={this.onEditCell} />
              )}
            />
            {this.state.impactColumns}
            <Column
              field="spi"
              title="% On Track"
              width="80px"
              // filter={"number"}
              // columnMenu={ColumnMenu}
            />
            <Column
              field="percentageCompletion"
              title="% Completion"
              width="100px"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="originalCompletionDate"
              width="100px"
              title="Original Completion Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="projectedCompletionDate"
              width="100px"
              title="Projected Completion Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="actualCompletionDate"
              width="100px"
              title="Actual Completion Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              // columnMenu={ColumnMenu}
            />

            <Column
              field="updatedDate"
              title="updated Date"
              width="100px"
              filter={"date"}
              // columnMenu={ColumnMenu}
              format="{0:dd-MMM-yyyy}"
            />
            <Column
              field="updatedBy"
              title="updated By"
              width="120px"
              editable={false}
            />
            <Column
              field="owner"
              title="Owner"
              width="100px"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="approved"
              title="Approved"
              cell={(props) => (
                <CheckBox {...props} onEditCell={this.onEditCell} />
              )}
              filter={"boolean"}
              width="100px"
              // columnMenu={ColumnMenu}
            />
            <Column
              field="isOpen"
              title="Status"
              width="80px"
              editor="boolean"
              cell={(props) => (
                <MitigationStatus {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="closedDate"
              title="Closed Date"
              width="120px"
              editor="date"
              filter={"date"}
              editable={false}
              format="{0:dd-MMM-yyyy}"
            />
            <Column
              field="departments"
              title="Departments"
              width="150px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="externalStatus"
              title="External Status"
              width="120px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <Column
              field="weeklyReport"
              title="Weekly Report"
              width="100px"
              // columnMenu={ColumnMenu}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
          </Grid>
        </div>
      </div>
    );
  }
}
